<template>
	<v-row align-content="center">
		<v-col
			cols="12"
			lg="2"
			align-self="center"
		>
			<media-gallery @selected="onSelect" />
		</v-col>
		<v-col>
			<v-img
				:src="src"
				max-width="150"
			/>
		</v-col>
	</v-row>
</template>

<script>
import MediaGallery from "./MediaGallery";

export default {
	name: "MediaGalleryPreview",
	components: {
		MediaGallery,
	},
	props: { value: String },
	computed: {
		src: {
			get () {
				return this.value;
			},
			set (val) {
				this.$emit("input", val);
			},
		},
	},
	methods: {
		onSelect (val) {
			this.src = val;
		},
	},
};
</script>

<style scoped>

</style>
